import { ApiService } from './apiService';
import { API_ENDPOINTS } from '../config/api';
import { appendQueryString } from '../utils/queryParams';
import { Branch, CreateBranchRequest } from '../types/branch';

interface BranchApi {
  branch_id: number;
  name: string;
  is_active: boolean;
}

const mapBranch = (branch: BranchApi): Branch => ({
  branchId: Number(branch.branch_id),
  name: branch.name,
  isActive: branch.is_active,
});

export class BranchService extends ApiService {
  async getBranches(includeInactive = false): Promise<Branch[]> {
    const url = appendQueryString(API_ENDPOINTS.branches.list, {
      includeInactive: includeInactive ? 'true' : undefined,
    });
    const rows = await this.get<BranchApi[]>(url);
    return rows.map(mapBranch);
  }

  async createBranch(data: CreateBranchRequest): Promise<Branch> {
    const created = await this.post<BranchApi>(API_ENDPOINTS.branches.create, data);
    return mapBranch(created);
  }
}

export const branchService = new BranchService();
